import React from 'react';
import usePopper from './usePopper';
import { uid } from '../_utils';
import { Placements } from './TooltipPlacementType';
import './Tooltip.css';
var Tooltip = function (props) {
    var content = props.content, _a = props.variant, variant = _a === void 0 ? 'primary' : _a, _b = props.placement, placement = _b === void 0 ? Placements.Auto : _b, children = props.children, className = props.className;
    var _c = usePopper(placement), triggerRef = _c[0], popupRef = _c[1], isVisible = _c[2], currentPlacement = _c[3], showHandler = _c[4], hideHandler = _c[5];
    var id = uid('O_tooltip');
    var getSelectedVariant = function (variant) {
        switch (variant) {
            case 'primary':
            default:
                return 'white';
            case 'dark':
                return 'dark';
        }
    };
    var getSelectedFirtPlacement = function (placement) {
        switch (placement) {
            case Placements.Top:
            case Placements.TopStart:
            case Placements.TopEnd:
                return Placements.Top;
            case Placements.Right:
            case Placements.RightStart:
            case Placements.RightEnd:
                return Placements.Right;
            case Placements.Bottom:
            case Placements.BottomStart:
            case Placements.BottomEnd:
                return Placements.Bottom;
            case Placements.Left:
            case Placements.LeftStart:
            case Placements.LeftEnd:
                return Placements.Left;
            case Placements.Auto:
            default:
                return Placements.Auto;
        }
    };
    var getArrowAligment = function (placement) {
        var placements = placement && placement.split('-');
        var aligment = 'center';
        if (placements && placements.length === 2) {
            var secondPlacement = placements[1];
            if (secondPlacement === 'start')
                aligment = 'start';
            else if (secondPlacement === 'end')
                aligment = 'end';
        }
        return aligment;
    };
    var getStyle = function (variant, placement) {
        var selectedPlacement = getSelectedFirtPlacement(placement);
        var selectedVariant = getSelectedVariant(variant);
        var arrowAligment = getArrowAligment(placement);
        return "tooltip b-tooltip-" + selectedVariant + " b-tooltip bs-tooltip-" + selectedPlacement + " " + arrowAligment;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tooltip-component", onMouseEnter: showHandler, onMouseLeave: hideHandler, onFocus: showHandler, onBlur: hideHandler, ref: triggerRef, "aria-describedby": id, onClick: hideHandler }, children),
        React.createElement("div", { id: id, role: "tooltip", className: "" + getStyle(variant, currentPlacement != null ? currentPlacement : placement) + (className ? " " + className : ''), ref: popupRef }, isVisible && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "arrow" }),
            React.createElement("div", { className: "tooltip-inner" }, content))))));
};
export default Tooltip;
